import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.veranstaltungs-typ-anlegen';
import * as api from '../../../clients/veranstaltungstypen';

@Injectable()
export class VeranstaltungstypenVeranstaltungsTypAnlegenEffects {

    VeranstaltungsTypAnlegen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_VERANSTALTUNGS_TYP_ANLEGEN),
        mergeMap((x: ac.PostVeranstaltungsTypAnlegenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postVeranstaltungsTypAnlegen(x.veranstaltungsTypStammRequest).pipe(
                map((result: any) => {
                    return new ac.PostVeranstaltungsTypAnlegenErfolgreichAction(result, x.veranstaltungsTypStammRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostVeranstaltungsTypAnlegenFehlerAction(error, x.veranstaltungsTypStammRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VeranstaltungsTypenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VeranstaltungsTypenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.VeranstaltungsTypenCommandService);
        }
        return this.service;
    }
}
